// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K6bgKdwDLpO0VuIeBbl6 {
  display: flex;
}

.Wlzvz7gcAXNxtHLXVnml {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 4px;
}

.qN8xgekmnT_SnihdClev {
  width: 100%;
  height: 60px;
}

.qJ5sPXeqOBH1C0yJo4kW {
  overflow-x: auto;
}

.REekRiJBodihtUek87J4 {
  min-width: 175px;
}

.W5uQk7EwQn1WpGdUAwYZ {
  position: relative;
  top: -1px;
  display: flex;
  align-items: center;
}

.QVDvnkwbzQkLpArkrFVI {
  height: 18px;
  width: 1px;
  background: rgba(0, 33, 54, 0.3764705882);
  position: relative;
  top: 3px;
}

.Z0YApJSHAhD9f3nZTfwa {
  display: flex;
  justify-content: center;
  flex-direction: row;
  line-height: 16px;
  font-size: 16px;
  font-weight: 300;
  gap: -2px;
  position: relative;
  top: 6px;
}

.wEy5wa1J3YdQeAagmxeL {
  display: flex;
  justify-content: center;
  line-height: 32px;
  font-size: 20px;
  font-weight: 500;
  gap: 8px;
  flex-direction: row;
  position: relative;
  top: 6px;
}

.CGhA4M7ci8G8_rs3W8Ox {
  position: relative;
  top: -2px;
}`, "",{"version":3,"sources":["webpack://./src/components/LevelFunctionMatrix/LevelFunctionMatrix.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,UAAA;EACA,yCAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;AACF","sourcesContent":[".container {\n  display: flex;\n}\n\n.yHeaders {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0 4px;\n}\n\n.emptyCorner {\n  width: 100%;\n  height: 60px;\n}\n\n.scrollable {\n  overflow-x: auto;\n}\n\n.dataCell {\n  min-width: 175px;\n}\n\n.cohortCellScore {\n  position: relative;\n  top: -1px;\n  display: flex;\n  align-items: center;\n}\n\n.cohortCellPipe {\n  height: 18px;\n  width: 1px;\n  background: #00213660;\n  position: relative;\n  top: 3px;\n}\n\n.cohortCellIcon {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  line-height: 16px;\n  font-size: 16px;\n  font-weight: 300;\n  gap: -2px;\n  position: relative;\n  top: 6px;\n}\n\n.cohortCell {\n  display: flex;\n  justify-content: center;\n  line-height: 32px;\n  font-size: 20px;\n  font-weight: 500;\n  gap: 8px;\n  flex-direction: row;\n  position: relative;\n  top: 6px;\n}\n\n.cohortPerson {\n  position: relative;\n  top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `K6bgKdwDLpO0VuIeBbl6`,
	"yHeaders": `Wlzvz7gcAXNxtHLXVnml`,
	"emptyCorner": `qN8xgekmnT_SnihdClev`,
	"scrollable": `qJ5sPXeqOBH1C0yJo4kW`,
	"dataCell": `REekRiJBodihtUek87J4`,
	"cohortCellScore": `W5uQk7EwQn1WpGdUAwYZ`,
	"cohortCellPipe": `QVDvnkwbzQkLpArkrFVI`,
	"cohortCellIcon": `Z0YApJSHAhD9f3nZTfwa`,
	"cohortCell": `wEy5wa1J3YdQeAagmxeL`,
	"cohortPerson": `CGhA4M7ci8G8_rs3W8Ox`
};
export default ___CSS_LOADER_EXPORT___;
